import { render, staticRenderFns } from "./ProductoUnidadMedidaSelectComponent.vue?vue&type=template&id=8283cf0a&"
import script from "./ProductoUnidadMedidaSelectComponent.vue?vue&type=script&lang=js&"
export * from "./ProductoUnidadMedidaSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports